import { Link } from "react-router-dom";
import { Facebook, BookOpen, MessageCircle, CalendarHeart, Bell, LockKeyhole, UsersRound } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import EmailCaptureCTA from "@/components/EmailCaptureCTA";

const GROUP_IMGS = [
  "https://images.pexels.com/photos/1706017/pexels-photo-1706017.jpeg?auto=compress&w=600",
  "https://images.unsplash.com/photo-1739302750675-042ed497a429?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1630726410985-a1021e8a232a?auto=format&fit=crop&w=600&q=80",
];
const features = [
  { Icon: UsersRound, t: "Create a Profile", d: "Introduce yourself and connect with women who share your love of books." },
  { Icon: BookOpen, t: "Current & Upcoming Reads", d: "Always know what the room is reading next and read at your own pace." },
  { Icon: CalendarHeart, t: "RSVP for Gatherings", d: "Reserve your seat at brunches, dinners, wine nights, and reading nights." },
  { Icon: MessageCircle, t: "Book Discussions", d: "Join thoughtful conversations and respond to monthly discussion prompts." },
  { Icon: Bell, t: "Announcements", d: "Stay in the loop with updates straight from The Mahogany Room." },
  { Icon: LockKeyhole, t: "Member-Only Resources", d: "Reading guides, conversation starters, and community perks." },
];

export default function Community() {
  return (
    <div data-testid="community-page">
      <PageHeader overline="Sisterhood" script="You found your people." title="The Community" subtitle="A welcoming space where Black women connect, support one another, and build genuine, lifelong relationships." />

      <section className="py-24 bg-mahogany-900">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((f, i) => (
            <Reveal key={f.t} delay={i * 0.06}>
              <div className="h-full bg-mahogany-800/40 gold-frame rounded-sm p-8" data-testid={`community-feature-${i}`}>
                <div className="w-12 h-12 rounded-full border border-gold/40 flex items-center justify-center mb-5"><f.Icon size={20} className="text-gold" strokeWidth={1.25} /></div>
                <h3 className="font-serif text-2xl text-cream mb-2">{f.t}</h3>
                <p className="text-cream/60 text-sm leading-relaxed">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24 bg-gradient-to-br from-mahogany-800 to-mahogany-950">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <Reveal>
            <div className="flex justify-center gap-4 mb-10">
              {GROUP_IMGS.map((src) => (
                <div key={src} className="w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden border-2 border-gold/40">
                  <img src={src} alt="Community members" className="w-full h-full object-cover" />
                </div>
              ))}
            </div>
            <p className="overline mb-4">Join Our Private Community</p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light text-cream mb-6">Connect With Amazing Women Who Love Books & Real Talk</h2>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="https://www.facebook.com/people/The-Mahogany-Room-A-Literary-Society-for-Black-Women/61593363442767/" target="_blank" rel="noreferrer" data-testid="join-facebook-group" className="btn-primary inline-flex items-center gap-2"><Facebook size={18} /> Join Our Facebook Group</a>
              <Link to="/join" className="btn-secondary" data-testid="community-join-room">Create a Free Account</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <EmailCaptureCTA />
    </div>
  );
}
